import React, { useEffect, useState } from 'react'
import ArtistCard from './ArtistCard'
import axios from 'axios';

import './ArtistsListingPage.css';
import TrendingArtistCard from './TrendingArtistCard';
import ArtistCardType2 from './ArtistCardType2';
import CategoryWiseArtist from './CategoryWiseArtist';
import { API_BASE_URL } from '../../utils';



export default function ArtistsListingPage() {

    var url = `${API_BASE_URL}/master/assets/uploads/`;


    const [artitst, setArtitst] = useState([]);
    const [artitstTop10, setArtitstTop10] = useState([]);
    const [specialArtist, setSpecialArtist] = useState([]);
    const [categories, setCategories] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const fetchURL = async () => {
        setIsLoading(true);
        try {
            const response = await axios.get(
                `${API_BASE_URL}/master/APIs/Artist/trendingArtist`
            );
            setArtitst(response.data.data);
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }

    };

    const fetchURLTop10 = async () => {
        try {
            const response = await axios.get(
                `${API_BASE_URL}/master/APIs/Artist/top10Artist`
            );
            setArtitstTop10(response.data.data);
        } catch (error) {
            console.log(error);
        }
    };

    const fetchSpecialArtist = async () => {
        try {
            const response = await axios.get(
                `${API_BASE_URL}/master/APIs/Artist/specialArtist`
            );
            setSpecialArtist(response.data.data);
        } catch (error) {
            console.log("Error fetching data:", error);
        }
    };

    const fetchCategoryWiseArtist = async () => {
        try {
            const response = await axios.get(
                `${API_BASE_URL}/master/APIs/Artist/categoryWiseArtist`
            );
            setCategories(response.data.data);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        fetchURL();
    }, []);




    useEffect(() => {
        fetchCategoryWiseArtist();
        fetchSpecialArtist();
        fetchURLTop10();
        fetchURL();
    }, []);



    return (
        <div className='artists-listing-page'>
            <ArtistCard specialArtist={specialArtist} />
            <div className='trending-artist-card-section'>
                <h1>
                    Trending Artists
                </h1>
                <div className='trending-artist-card-list-section'>
                    {artitst.map((item, index) => (
                        <TrendingArtistCard key={index} data={item} />
                    ))}
                </div>
            </div>

            <div className='trending-top-artist-card-section'>
                <div className='trending-artist-background'></div>
                <div className='trending-artist-card-wrapper-overlay'>
                    <div className='trending-artist-card-section'>
                        <h1>
                            Top 10 Artists
                        </h1>
                        <div className='trending-artist-card-list-section-top'>
                            <div className='trending-artist-card-list-section-top-inner'>
                                {artitstTop10.map((item, index) => (
                                    <ArtistCardType2 key={index} data={item} number={index + 1} />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

              <div className='trending-artist-card-section'>
                <h1>
                    Category Wise Artists
                </h1>
                <div className='category-artist-list-card-list-section'>
                        <CategoryWiseArtist  data={categories} />
                </div>
            </div>

         

        </div>
    )
}
